module.exports = __webpack_public_path__ + "static/article2-fbd8630ef00644b867e2cddddab94ebb.png";